import { Menus } from "../../../components/Menu/idex";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { api } from "../../../Api/ApiService";
import img_cachorro from "../../../assets/cachorro-teste.png";
import img_gato from "../../../assets/gato-teste.png";
import { Container } from "./styles";
import { FormLabel } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigator = useNavigate();
  return (
    <>
      <Menus />
      <Container>
        <div className="categorias">
          <button
            onClick={() => {
              navigator("/animais/1");
            }}
          >
            <div className="categoria">
              <img className="img" src={img_cachorro}></img>
              <FormLabel className="labels">CACHORRO</FormLabel>
            </div>
          </button>
          <button
            onClick={() => {
              navigator("/animais/2");
            }}
          >
            <div className="categoria">
              <img className="img" src={img_gato}></img>
              <FormLabel className="labels">GATO</FormLabel>
            </div>
          </button>
        </div>
      </Container>
    </>
  );
};

export { Home };
